import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import { FaRegNewspaper } from "react-icons/fa";
import "./Header.css";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isIntlHovered, setIsIntlHovered] = useState(false);
  const [isInsHovered, setIsInsHovered] = useState(false);

  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    document.body.classList.toggle("mobile-menu-visible");
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    document.body.classList.remove("mobile-menu-visible");
  };

  return (
    <div>
      <Helmet>
        <title>Columbiaa Hospital | Best Multi-Speciality Hospital in Kasturi Nagar, Bangalore</title>
        <meta name="description" content="Columbiaa Hospital - Leading multi-speciality hospital in Kasturi Nagar, Bangalore with top doctors, advanced medical facilities, and comprehensive healthcare services." />
        <meta name="keywords" content="Columbiaa Hospital, Kasturi Nagar, Bangalore, multi-speciality hospital, doctors, healthcare, medical services, cardiology, neurology, orthopedics" />
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "Hospital",
              "name": "Columbiaa Hospital",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "Building No 06, 5th Main Rd, B Channasandra, OMBR Layout, bengaluru",
                "addressLocality": "Kasturi Nagar",
                "addressRegion": "Karnataka",
                "postalCode": "560043",
                "addressCountry": "IN"
              },
              "telephone": "+918044484444",
              "url": "https://columbiaahospital.com/",
              "sameAs": [
                "https://www.facebook.com/share/1BFLVsneD2/",
                "https://x.com/columbiaahosp",
                "https://www.linkedin.com/in/columbiaa-hospital-kasturi-nagar-bengaluru-98aa37323/",
                "https://www.instagram.com/columbiaahospital/",
                "https://www.youtube.com/@columbiaahospital"
              ]
            }
          `}
        </script>
      </Helmet>

      <div
  className="container-fluid py-3 px-3 contact-info1"
  data-aos="fade-down"
  style={{
    backgroundColor: "#1e1c42",
    color: "#fff",
    fontSize: "15px",
  }}
  role="banner"
  aria-label="Contact information and quick links"
>
  <div className="d-flex flex-column flex-md-row flex-wrap align-items-center justify-content-between">
    
    {/* Contact Info */}
    <div className="d-flex flex-wrap align-items-center justify-content-center justify-content-md-start mb-2 mb-md-0 text-center text-md-left" role="region" aria-label="Contact phone numbers">
      <span className="d-none d-sm-inline mr-2" style={{fontWeight:'normal'}}>For Appointments :</span>
      <a
        href="tel:08044484444"
        className="mx-1 text-white text-decoration-none"
        title="Book appointments at Columbiaa Hospital"
        aria-label="Book appointments: 080 4448 4444"
        style={{fontWeight:'normal'}}
      >
        <i className="fas fa-phone-alt mr-1" aria-hidden="true"></i>080 4448 4444 /
      </a>
      <a
        href="tel:08040939899"
        className="mx-1 text-white text-decoration-none"
        title="General enquiry at Columbiaa Hospital"
        aria-label="General enquiry: 080 4093 9899"
        style={{fontWeight:'normal'}}
      >
        080 4093 9899 /
      </a>
      <a
        href="tel:+918548979899"
        className="mx-1 text-white text-decoration-none"
        title="Emergency contact Columbiaa Hospital"
        aria-label="Emergency: +91 85489 79899"
        style={{fontWeight:'normal'}}
      >
        +91 85489 79899
      </a>
    </div>

    {/* Social Links */}
    <div className="d-flex align-items-center justify-content-center mb-2 mb-md-0" role="region" aria-label="Social media links">
      <span className="mr-2 d-none d-sm-inline" style={{fontWeight:'normal'}}>Stay Connected:</span>
      <a
        href="https://www.facebook.com/columbiaahospital"
        className="text-white mx-2"
        target="_blank"
        rel="noopener noreferrer"
        title="Follow Columbiaa Hospital on Facebook"
        aria-label="Visit Columbiaa Hospital Facebook page"
      >
        <i className="fab fa-facebook-f" aria-hidden="true"></i>
      </a>
      <a
        href="https://x.com/columbiaahosp"
        className="text-white mx-2"
        target="_blank"
        rel="noopener noreferrer"
        title="Follow Columbiaa Hospital on X (Twitter)"
        aria-label="Visit Columbiaa Hospital X (Twitter) profile"
      >
        X
      </a>
      <a
        href="https://www.linkedin.com/in/columbiaa-hospital-kasturi-nagar-bengaluru-98aa37323/"
        className="text-white mx-2"
        target="_blank"
        rel="noopener noreferrer"
        title="Follow Columbiaa Hospital on LinkedIn"
        aria-label="Visit Columbiaa Hospital LinkedIn page"
      >
        <i className="fab fa-linkedin-in" aria-hidden="true"></i>
      </a>
      <a
        href="https://www.instagram.com/columbiaahospital/"
        className="text-white mx-2"
        target="_blank"
        rel="noopener noreferrer"
        title="Follow Columbiaa Hospital on Instagram"
        aria-label="Visit Columbiaa Hospital Instagram profile"
      >
        <i className="fab fa-instagram" aria-hidden="true"></i>
      </a>
      <a
        href="https://www.youtube.com/@columbiaahospital"
        className="text-white mx-2"
        target="_blank"
        rel="noopener noreferrer"
        title="Subscribe to Columbiaa Hospital on YouTube"
        aria-label="Visit Columbiaa Hospital YouTube channel"
      >
        <i className="fab fa-youtube" aria-hidden="true"></i>
      </a>
    </div>

{/* International Desk */}
<div className="mb-2 mb-md-0 text-center">
  <a
    href="/international-patient-desk"
    className="text-white text-decoration-none"
    style={{
      fontWeight: "normal",
      display: "inline-block",
      transition: "transform 0.3s ease",
      transform: isIntlHovered ? "scale(1.1)" : "scale(1)",
    }}
    onMouseEnter={() => setIsIntlHovered(true)}
    onMouseLeave={() => setIsIntlHovered(false)}
    title="International Patient Desk at Columbiaa Hospital"
    aria-label="International Patient Desk - For patients from abroad"
  >
    International Patient Desk
  </a>
</div>

{/* Insurances */}
<div className="mb-2 mb-md-0 text-center">
  <a
    href="/insurances"
    className="text-white text-decoration-none"
    style={{
      fontWeight: "normal",
      display: "inline-block",
      transition: "transform 0.3s ease",
      transform: isInsHovered ? "scale(1.1)" : "scale(1)",
    }}
    onMouseEnter={() => setIsInsHovered(true)}
    onMouseLeave={() => setIsInsHovered(false)}
    title="Insurance services at Columbiaa Hospital"
    aria-label="Insurance services - Cashless treatment and empanelled TPAs"
  >
    Insurances
  </a>
</div>

    {/* Buttons */}
    <div className="d-flex justify-content-center" role="group" aria-label="Quick navigation buttons">
      <button
        className="btn btn-light mx-1"
        style={{ color: "#1e1c42" }}
        onClick={() => navigate("/our-blogs")}
        title="Read health blogs from Columbiaa Hospital"
        aria-label="Read health blogs and medical articles"
      >
        Blogs
      </button>
      <button
        className="btn btn-light mx-1"
        style={{ color: "#1e1c42" }}
        onClick={() => navigate("/contacts")}
        title="Contact Columbiaa Hospital"
        aria-label="Contact us - Get in touch with Columbiaa Hospital"
      >
        Contacts
      </button>
      <button
        className="btn btn-light mx-1 blinking-btn"
        style={{ color: "#1e1c42" }}
        onClick={() => navigate("/latest-news")}
        title="Latest news and updates from Columbiaa Hospital"
        aria-label="Latest news - Stay updated with hospital announcements"
      >
        <FaRegNewspaper style={{ marginRight: "8px", color: "#ffcc00" }} aria-hidden="true" />
        News Bulletin
      </button>
    </div>

  </div>
</div>

      <header className="main-header" role="banner">
       <div className="header-lower">
  <div className="outer-box clearfix" id="header-outerBox">
    <div className="menu-area pull-left clearfix" id="headerBox">
      <div id="logo-area">
        <Link to="/" title="Columbiaa Hospital Home - Leading Multi-Speciality Hospital in Bangalore">
          <img
            src="assets/images/zclogo.png"
            alt="Columbiaa Hospital Logo - Best Multi-Speciality Hospital in Kasturi Nagar, Bangalore"
            loading="lazy"
          />
        </Link>
      </div>

      {/* Mobile Navigation Toggler */}
      <div className="mobile-nav-toggler" onClick={toggleMenu} aria-label="Toggle mobile menu" role="button" tabIndex={0}>
        <i className="icon-bar" aria-hidden="true"></i>
        <i className="icon-bar" aria-hidden="true"></i>
        <i className="icon-bar" aria-hidden="true"></i>
      </div>

      <nav className="main-menu navbar-expand-md navbar-light" aria-label="Main navigation">
        <div
          className="collapse navbar-collapse show clearfix"
          id="navbarSupportedContent"
        >
          <ul
            className="navigation clearfix px-3 d-flex flex-wrap flex-md-nowrap"
            style={{ marginTop: "-10px" }}
            role="menubar"
          >
            <li role="none">
              <Link
                to="/"
                title="Columbiaa Hospital Home - Best Healthcare in Bangalore"
                aria-label="Home – Columbiaa Hospital"
                role="menuitem"
              >
                Home
              </Link>
            </li>
            <li role="none">
              <Link
                to="about-us"
                title="About Columbiaa Hospital - Our Mission and Vision"
                aria-label="About Us – Learn about Columbiaa Hospital"
                role="menuitem"
              >
                About
              </Link>
            </li>
            <li role="none">
              <Link
                to="services"
                title="Medical Services at Columbiaa Hospital - Comprehensive Healthcare"
                aria-label="Services – Columbiaa Hospital Medical Services"
                role="menuitem"
              >
                Services
              </Link>
            </li>
            <li role="none">
              <Link
                to="doctors"
                title="Our Doctors – Top Medical Professionals at Columbiaa Hospital"
                aria-label="Doctors – Meet Our Expert Doctors"
                role="menuitem"
              >
                Doctors
              </Link>
            </li>
            <li role="none">
              <Link
                to="departments"
                title="Hospital Departments at Columbiaa Hospital - Specialised Care"
                aria-label="Departments – Explore Our Specialised Departments"
                role="menuitem"
              >
                Departments
              </Link>
            </li>
            <li role="none">
              <Link
                to="lab-dialysis"
                title="Lab and Dialysis Services at Columbiaa Hospital"
                aria-label="Lab / Dialysis – Our Diagnostic and Dialysis Services"
                role="menuitem"
              >
                Lab / Dialysis
              </Link>
            </li>
            <li role="none">
              <Link
                to="health-packages"
                title="Health Check-up Packages at Columbiaa Hospital"
                aria-label="Health Packages – View Our Health Check-up Packages"
                role="menuitem"
              >
                Health Packages
              </Link>
            </li>
            <li role="none">
              <Link
                to="gallery"
                title="Photo Gallery of Columbiaa Hospital - Our Facilities and Events"
                aria-label="Gallery – View Columbiaa Hospital Photo Gallery"
                role="menuitem"
              >
                Gallery
              </Link>
            </li>
          </ul>
        </div>
      </nav>
    </div>

    {/* Right side menu (book appointment button) */}
    <ul
      className="menu-right-content pull-right clearfix mt-1 d-flex align-items-center"
      id="menu-right-content"
      role="group"
      aria-label="Book appointment action"
    >
      <li>
        <button
          className="theme-btn-one"
          onClick={() => navigate("/book-appointment")}
          title="Book an appointment with a doctor at Columbiaa Hospital"
          aria-label="Book an appointment with a doctor at Columbiaa Hospital"
        >
          Book Appointment
        </button>
      </li>
    </ul>
  </div>
</div>

        {/* Sticky Header */}
        <div className="sticky-header" role="banner" aria-label="Sticky navigation header">
          <div className="outer-box clearfix">
            <div className="menu-area pull-left">
              <figure
                className=""
                style={{
                  background: "#f0e6e0",
                  width: "330px",
                  borderRadius: "0px 0 32px 0",
                  paddingTop: "10px",
                  paddingLeft:"40px",
                }}
              >
                <Link to="/" title="Go to Columbiaa Hospital homepage" aria-label="Columbiaa Hospital homepage">
                  <img
                    src="assets/images/zclogo.png"
                    alt="Columbiaa Hospital Logo - Sticky Header"
                    title="Columbiaa Hospital - Multi-Speciality Hospital in Bangalore"
                    aria-label="Columbiaa Hospital logo for sticky header"
                    width="200px"
                    loading="lazy"
                  />
                </Link>
              </figure>

              <nav
                className="navigations clearfix"
                aria-label="Sticky header main navigation"
              >
                <li role="none">
                  <Link to="/" title="Home page - Columbiaa Hospital" aria-label="Home" role="menuitem">
                    Home
                  </Link>
                </li>
                <li role="none">
                  <Link
                    to="about-us"
                    title="About Columbiaa Hospital"
                    aria-label="About" role="menuitem"
                  >
                    About
                  </Link>
                </li>
                <li role="none">
                  <Link
                    to="services"
                    title="Explore our medical services"
                    aria-label="Services" role="menuitem"
                  >
                    Services
                  </Link>
                </li>
                <li role="none">
                  <Link
                    to="doctors"
                    title="Meet our expert doctors"
                    aria-label="Doctors" role="menuitem"
                  >
                    Doctors
                  </Link>
                </li>
                <li role="none">
                  <Link
                    to="departments"
                    title="View hospital departments"
                    aria-label="Departments" role="menuitem"
                  >
                    Departments
                  </Link>
                </li>
                <li role="none">
                  <Link
                    to="lab-dialysis"
                    title="Explore Our Lab / Dialysis Services"
                    aria-label="Lab / Dialysis" role="menuitem"
                  >
                    Lab / Dialysis
                  </Link>
                </li>
                <li role="none">
                  <Link
                    to="health-packages"
                    title="Health check-up packages"
                    aria-label="Health Packages" role="menuitem"
                  >
                    Health Packages
                  </Link>
                </li>
                <li role="none">
                  <Link
                    to="gallery"
                    title="Gallery of our hospital"
                    aria-label="Gallery" role="menuitem"
                  >
                    Gallery
                  </Link>
                </li>
              </nav>
            </div>

            <ul
              className="menu-right-content pull-right clearfix mt-1"
              id="menu-right-content"
              role="group"
              aria-label="Book appointment"
            >
              <li>
                <button
                  className="theme-btn-one"
                  onClick={() => navigate("/book-appointment")}
                  title="Book your appointment now at Columbiaa Hospital"
                  aria-label="Book Appointment"
                >
                  Book Appointment
                </button>
              </li>
            </ul>
          </div>
        </div>
      </header>

      {/* Mobile menu */}
      <div className={`mobile-menu ${isMenuOpen ? "mobile-menu-visible" : ""}`} role="navigation" aria-label="Mobile menu">
        <div className="menu-backdrop" onClick={closeMenu} aria-hidden="true"></div>
        <div className="close-btn" onClick={closeMenu} aria-label="Close mobile menu" role="button" tabIndex={0}>
          <i className="fas fa-times" aria-hidden="true"></i>
        </div>
        <nav className="menu-box" aria-label="Mobile navigation">
          <div className="menu-outer">
            <nav aria-label="Mobile Main Navigation">
              <ul className="navigation clearfix" role="menubar">
                <li role="none">
                  <Link to="/" aria-label="Home Page" role="menuitem">
                    Home
                  </Link>
                </li>
                <li role="none">
                  <Link to="about-us" aria-label="About Us Page" role="menuitem">
                    About
                  </Link>
                </li>
                <li role="none">
                  <Link to="services" aria-label="Services Page" role="menuitem">
                    Services
                  </Link>
                </li>
                <li role="none">
                  <Link to="doctors" aria-label="Doctors Page" role="menuitem">
                    Doctors
                  </Link>
                </li>
                <li role="none">
                  <Link to="departments" aria-label="Departments Page" role="menuitem">
                    Departments
                  </Link>
                </li>
                <li role="none">
                  <Link to="lab-dialysis" aria-label="Lab and Dialysis Page" role="menuitem">
                    Lab / Dialysis
                  </Link>
                </li>
                <li role="none">
                  <Link to="health-packages" aria-label="Health Packages Page" role="menuitem">
                    Health Packages
                  </Link>
                </li>
                <li role="none">
                  <Link to="gallery" aria-label="Gallery Page" role="menuitem">
                    Gallery
                  </Link>
                </li>
                <li role="none">
                  <Link to="contacts" aria-label="Contact Page" role="menuitem">
                    Contact Us
                  </Link>
                </li>
              </ul>
            </nav>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Header;
